class CountdownTimer {
  constructor(dateTimeElement, container, shorter) {
    this.dataTime = dateTimeElement;
    this.container = container;
    this.shorter = shorter;
  }

  render = () => {
    const presaleElement = document.querySelector(this.dataTime);

    if (!presaleElement) {
      setTimeout(this.render, 1000);
      return;
    }

    if (presaleElement && presaleElement.getAttribute('data-time')) {
      const startTime = new Date(presaleElement.getAttribute('data-time').valueOf());
      const startTimeUTC = new Date(startTime.toUTCString()).getTime();

      const countdownElement = document.getElementById(this.container);

      const countdownInterval = setInterval(() => {
        const currentTime = new Date().getTime();

        const remainingTime = startTimeUTC - currentTime;
        const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

        const daysSuffix = handleNumeralWords(['dzień', 'dni', 'dni'], days);

        countdownElement.innerHTML = `
                <div class='font-semibold mr-[2px] ${days === 0 && 'hidden'}'>${days}${this.shorter ? 'd' : ' ' + daysSuffix}</div>
                <span class="px-[2px] ${(days === 0 || this.shorter) && 'hidden'}">:</span>
                <div class='font-semibold mx-[2px]'>${hours}${this.shorter ? 'g' : ' godz'}</div>
                <span class="px-[2px] ${this.shorter && 'hidden'}">:</span>
                <div class='font-semibold mx-[2px]'>${minutes}${this.shorter ? 'm' : ' min'}</div>
                <span class="px-[2px] ${this.shorter && 'hidden'}">:</span>
                <div class='font-semibold ml-[2px]' style="min-width: ${this.shorter ? '22px' : '38px'};">${seconds}${this.shorter ? 's' : ' sek'}</div>
            `;
        if (presaleElement.classList.contains('hidden')) {
          presaleElement.classList.remove('hidden');
        }

        if (remainingTime < 0) {
          clearInterval(countdownInterval);
          countdownElement.innerHTML = '';
          presaleElement.classList.add('hidden');
        }
      }, 1000);
    }
  };
}
